// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3M-nt","box":"WorkspacesBox_box__1Fq2t","node":"WorkspacesBox_node__tAsdr"};